module.exports = __webpack_public_path__ + "static/media/square-root-alt.a75c9f04.svg";